import script from "./ModalEquipamentos.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEquipamentos.vue?vue&type=script&setup=true&lang=js"

import "./ModalEquipamentos.vue?vue&type=style&index=0&id=b76884ee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b76884ee"]])

export default __exports__